import { ErrorPage } from "./ErrorPage"

export const MissingPage = () => <ErrorPage errorCode="404" />
